export enum MediaFilterType {
    VIDEO = 'VIDEO',
    IMAGE = 'IMAGE',
    AUDIO = 'AUDIO',
    PDF = 'PDF',
    DOCUMENT = 'DOCUMENT',
    ANY = 'ANY',
}
export type MediaTypeFilterProps = {
    value?: MediaFilterType;
    onSelect: (type: MediaFilterType) => void;
    isDisabled?: boolean;
    showAudio?: boolean;
    showDocuments?: boolean;
};
